import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByPropNot',
  pure: false // Ensures updates when input values change
})
export class FilterByPropertyNotPipe implements PipeTransform {
    transform<T>(items: T[], key: keyof T, value: any): T[] {
        if (!items || !key) {
             return items;
        }
        return items.filter(item => item[key] != value);
    }
}